import React from 'react';
import ResourceItem from './ResourceItem';
import SectionIcon from './SectionIcon';

const ResourceSectionCard = ({ title, description, icon, items, className = '' }) => (
    <section
        className={`rounded-[16px] border border-[#e8e6e3] bg-white p-5 md:p-7 shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1)] ${className}`}
    >
        <div className="flex items-center gap-3">
            <SectionIcon name={icon} />
            <h2 className="text-[18px] leading-[26px] font-medium text-[#2d2d2d]">
                {title}
            </h2>
        </div>

        <p className="mt-3.5 text-[13px] leading-5 text-[#6b6b6b]">
            {description}
        </p>

        <div className="mt-5 flex flex-col">
            {items.map((item) => (
                <ResourceItem key={item.id} {...item} />
            ))}
        </div>
    </section>
);

export default ResourceSectionCard;
